import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const GenerateAllSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 24px;
  border-top: 2px solid ${COLORS.border};
  background-color: ${COLORS.surface};
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
`

export const GenerateAllButton = styled.button`
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.white};
  background: ${COLORS.primary};
  border: none;
  border-radius: ${RADII.field};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);

  &:hover:not(:disabled) {
    background: ${COLORS.primaryHover};
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus:not(:disabled) {
    outline: none;
    box-shadow:
      0 0 0 3px rgba(79, 70, 229, 0.2),
      0 4px 12px rgba(79, 70, 229, 0.3);
  }

  &:disabled {
    background: ${COLORS.placeholder};
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }
`
